import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { ColorMode, LUXProvider, LUXV2Theme } from '@lux/core';

import { getWebviewOs, getWebviewTheme } from '@client/redux/modules/clientDevice';

export const LUXProviderWrapper: FC = ({ children }) => {
    const webviewOs = useSelector(getWebviewOs);
    const webviewTheme = useSelector(getWebviewTheme);

    return (
        <LUXProvider
            initialColorMode={
                webviewOs && webviewOs !== '' && webviewTheme === 'dark'
                    ? ColorMode.DARK
                    : ColorMode.LIGHT
            }
            LUXTheme={LUXV2Theme}
            features={{ roundedButton: true }}
        >
            {children}
        </LUXProvider>
    );
};
